/*eslint no-multi-spaces:0*/
define([
    'lodash',
    'componentsCore',
    'santa-components',
    'skins',
    'skypeCallButton/skins/skins.json'
], function (_, componentsCore, santaComponents, skinsPackage, skinsJson) {
    'use strict';

    const SKYPE_SIZES = {
        call: {
            small: {width: 38, height: 16},
            medium: {width: 56, height: 24},
            large: {width: 73, height: 32}
        },
        chat: {
            small: {width: 45, height: 16},
            medium: {width: 65, height: 24},
            large: {width: 86, height: 32}
        }
    };

    function getSkypeLinkAriaLabel(buttonType) {
        return `${_.capitalize(buttonType)} via Skype`;
    }

    /**
     * @class components.SkypeCallButton
     * @extends {core.skinBasedComp}
     */
    const skypeCallButton = {
        displayName: 'SkypeCallButton',
        mixins: [componentsCore.mixins.skinBasedComp],
        propTypes: {
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired,
            compProp: santaComponents.santaTypesDefinitions.Component.compProp.isRequired
        },
        getInitialState() {
            const data  = this.props.compData,
                props = this.props.compProp;

            return {
                $buttontype: data.buttonType,
                $imagesize: props.imageSize,
                $imagecolor: props.imageColor
            };
        },
        componentWillReceiveProps(nextProps) {
            const data = nextProps.compData;
            const props = nextProps.compProp;
            this.setState({
                $buttontype: data.buttonType,
                $imagesize: props.imageSize,
                $imagecolor: props.imageColor
            });
        },
        getSkinProperties() {
            const data  = this.props.compData,
                props = this.props.compProp,
                size  = SKYPE_SIZES[data.buttonType][props.imageSize];

            // fallback for placeholder
            const result = {
                '': {
                    style: {
                        width: size.width,
                        height: size.height
                    }
                },
                'placeholder': {
                    parentConst: santaComponents.utils.createReactElement.bind(null, 'div'),
                    style: {
                        display: 'block',
                        width: size.width,
                        height: size.height
                    }
                }
            };

            if (data.skypeName) {
                result.skypeLink = {
                    href: `skype:${data.skypeName}?${data.buttonType}`,
                    'aria-label': getSkypeLinkAriaLabel(this.props.compData.buttonType),
                    title: getSkypeLinkAriaLabel(this.props.compData.buttonType)
                };
            }
            return result;
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.common.components.skypecallbutton.viewer.SkypeCallButton', skypeCallButton);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return skypeCallButton;
});
